import { DUR, EASE } from '@/animations/settings/vars'
import { AnimBaseProps } from '@/animations/types'
import { contextScrollVars, contextVars } from '@/animations/utils'
import { ScrollTrigger, gsap } from '@gsap'

const fadeIn = ({ ...props }: AnimBaseProps) => {
  gsap.registerPlugin(ScrollTrigger)
  if (!props?.ref?.current) {
    return
  }
  gsap.set(props.ref.current, {
    autoAlpha: 0,
    y: '2rem'
  })

  props.tl.current = gsap.to(props?.ref?.current, {
    autoAlpha: 1,
    duration: DUR.default,
    ease: EASE.out,
    clearProps: 'y',
    y: 0,
    ...contextVars(props.ctx, props.animVars),
    scrollTrigger: {
      trigger: props.ref.current,
      start: 'top bottom',
      ...contextScrollVars(props.ctx, props.animScrollVars)
    }
  })
}

export default fadeIn
